export default "__VITE_ASSET__BnbAK2Vw__$_?url__"